import { render, staticRenderFns } from "./attachment_view.vue?vue&type=template&id=528c9db1&scoped=true"
import script from "./attachment_view.vue?vue&type=script&lang=js"
export * from "./attachment_view.vue?vue&type=script&lang=js"
import style0 from "./attachment_view.vue?vue&type=style&index=0&id=528c9db1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528c9db1",
  null
  
)

export default component.exports